import { render, staticRenderFns } from "./DigitalH5Code.vue?vue&type=template&id=fb296ca8&scoped=true"
import script from "./DigitalH5Code.vue?vue&type=script&lang=js"
export * from "./DigitalH5Code.vue?vue&type=script&lang=js"
import style0 from "./DigitalH5Code.vue?vue&type=style&index=0&id=fb296ca8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb296ca8",
  null
  
)

export default component.exports